module.exports = __webpack_public_path__ + "static/media/electricBolt.721fccb6.svg";